import { render, staticRenderFns } from "./ExamRecentExam.vue?vue&type=template&id=63ebc97c"
import script from "./ExamRecentExam.vue?vue&type=script&lang=js"
export * from "./ExamRecentExam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports